import React from 'react'


import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';

import { dateInputValue } from '../dates'

function NotificationInfo(props) {
  // Нет даты: напоминания у компании нет. Пустая дата превращалась в «1/1/1970».
  const hasReminder = Boolean(props.notification.noticeOn)

  return (
    <Grid component={Paper} container spacing={3}>
        <Grid item xs={8}>
          <Typography variant={'h5'} align={'center'}>
            Уведомления
            </Typography>
            </Grid>
        <Grid item xs={4}>
        <FormControl fullWidth>
        <Button variant="outlined" color="primary"
            onClick={props.editAction}>Настроить</Button>
            </FormControl>
        </Grid>
          <Grid item xs={6}>
            <Typography >
            Периодичность: {hasReminder ? `${props.notification.period} Дней` : "не задана"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
            {!hasReminder ? "Напоминание не настроено" : props.isProcesed?"Не проигнорировано   ":(<>
              Проигнорировано  
            <Button variant="outlined" color="secondary"
            onClick={()=>{
              // Копия: объект из store не меняем. Дата остаётся той, что сохранена.
              props.marckAction({
                ...props.notification,
                noticeOn: dateInputValue(props.notification.noticeOn),
                isProcesed: true,
              })
            }}
            >Отметить</Button>
            </>)}
            </Typography>            
          </Grid>
          <Grid item xs={6}>
            <Typography>
            Напомнить: {hasReminder ? new Date(props.notification.noticeOn).toLocaleDateString() : "не задано"}
            </Typography>
          </Grid>
        </Grid>
  )
}

export default NotificationInfo